// File: src/pages/TabCommunications.js

import React from 'react';

function CommunicationTab() {
    return (
        <>
            <div className="card">
                {/* Title START */}
                <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Who can connect with you?</h5>
                    <p className="mb-0">
                        He moonlights difficult engrossed it, sportsmen. Interested
                        has all Devonshire difficulty gay assistance joy.
                        Unaffected at ye of compliment alteration to.
                    </p>
                </div>
                {/* Title START */}
                {/* Card body START */}
                <div className="card-body">
                    {/* Accordion START */}
                    <div className="accordion" id="communications">
                        {/* Accordion item */}
                        <div className="accordion-item bg-transparent">
                            <h2 className="accordion-header" id="communicationOne">
                                <button
                                    className="accordion-button mb-0 h6"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#communicationcollapseOne"
                                    aria-expanded="true"
                                    aria-controls="communicationcollapseOne"
                                >
                                    Connection request
                                </button>
                            </h2>
                            {/* Accordion info */}
                            <div
                                id="communicationcollapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="communicationOne"
                                data-bs-parent="#communications"
                            >
                                <div className="accordion-body">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="ComRadio"
                                            id="ComRadio5"
                                        />
                                        <label className="form-check-label" htmlFor="ComRadio5">
                                            Everyone on social (recommended)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="ComRadio"
                                            id="ComRadio2"
                                            defaultChecked
                                        />
                                        <label className="form-check-label" htmlFor="ComRadio2">
                                            Only people who know your email address
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="ComRadio"
                                            id="ComRadio3"
                                        />
                                        <label className="form-check-label" htmlFor="ComRadio3">
                                            Only people who appear in your mutual connection list
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Accordion item */}
                        <div className="accordion-item bg-transparent">
                            <h2 className="accordion-header" id="communicationTwo">
                                <button
                                    className="accordion-button mb-0 h6 collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#communicationcollapseTwo"
                                    aria-expanded="false"
                                    aria-controls="communicationcollapseTwo"
                                >
                                    Who can message you
                                </button>
                            </h2>
                            {/* Accordion info */}
                            <div
                                id="communicationcollapseTwo"
                                className="accordion-collapse collapse"
                                aria-labelledby="communicationTwo"
                                data-bs-parent="#communications"
                            >
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">
                                                    Enable message request notifications
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked"
                                                />
                                            </div>
                                        </li>
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">
                                                    Allow connections to add you on group
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked2"
                                                    defaultChecked
                                                />
                                            </div>
                                        </li>
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">Allow Sponsored Messages </p>
                                                <p className="small">
                                                    Your personal information is safe with our
                                                    marketing partners unless you respond to their
                                                    Sponsored Messages
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked3"
                                                    defaultChecked
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* Accordion item */}
                        <div className="accordion-item bg-transparent">
                            <h2 className="accordion-header" id="communicationThree">
                                <button
                                    className="accordion-button mb-0 h6 collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#communicationcollapseThree"
                                    aria-expanded="false"
                                    aria-controls="communicationcollapseThree"
                                >
                                    How people can find you
                                </button>
                            </h2>
                            {/* Accordion info */}
                            <div
                                id="communicationcollapseThree"
                                className="accordion-collapse collapse"
                                aria-labelledby="communicationThree"
                                data-bs-parent="#communications"
                            >
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">
                                                    Allow search engines to show your profile?
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked4"
                                                    defaultChecked
                                                />
                                            </div>
                                        </li>
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">
                                                    Allow people to search by your email address?
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked5"
                                                />
                                            </div>
                                        </li>
                                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0 py-1 border-0">
                                            <div className="me-2">
                                                <p className="mb-0">Allow Sponsored Messages </p>
                                                <p className="small">
                                                    Your personal information is safe with our
                                                    marketing partners unless you respond to their
                                                    Sponsored Messages
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="comSwitchCheckChecked6"
                                                    defaultChecked
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Accordion END */}
                </div>
                {/* Card body END */}
                {/* Button save */}
                <div className="card-footer pt-0 text-end border-0">
                    <button type="submit" className="btn btn-sm btn-primary mb-0">
                        Save changes
                    </button>
                </div>
            </div>
        </>
    );
}

export default CommunicationTab;